var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3116 15.2541C8.90255 14.2771 4.16287 15.3593 3.7243 17.674C3.28572 19.9887 7.31753 22.6566 12.7189 23.6411C18.128 24.618 22.8677 23.5359 23.3062 21.2212C23.7448 18.9065 19.713 16.2386 14.3116 15.2616V15.2541Z",
    fill: "url(#paint0_linear_3819_33370)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40132 15.2684C7.37106 14.314 10.7412 14.0434 14.4113 14.7048C18.0815 15.3661 21.1361 16.8015 22.6211 18.3797L23.9676 18.6202L23.5444 20.8522V20.8973L23.5291 20.9199C23.0289 23.2421 18.2354 24.3243 12.7724 23.3322C7.30951 22.3478 3.23923 19.6648 3.61625 17.3201L4.05482 15.0129L5.40132 15.2534V15.2684Z",
    fill: "url(#paint1_linear_3819_33370)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8188 12.5556C9.31741 11.5636 4.50079 12.6608 4.05452 15.0206C3.60826 17.3729 7.70161 20.0934 13.203 21.0854C18.7044 22.0774 23.5211 20.9802 23.9673 18.6204C24.4136 16.2681 20.3202 13.5476 14.8188 12.5556Z",
    fill: "url(#paint2_linear_3819_33370)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61599 14.9221C5.25436 16.846 8.73987 19.093 13.418 19.9347C18.0884 20.7764 22.1741 19.9047 22.5434 17.9808C22.905 16.0569 19.4195 13.8098 14.7414 12.9681C10.071 12.1264 5.98531 12.9982 5.61599 14.9221Z",
    fill: "url(#paint3_linear_3819_33370)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30038 15.329C5.96183 17.1026 9.15495 19.1692 13.4176 19.9358C17.6879 20.7099 21.4196 19.8982 21.7582 18.1246C22.0967 16.351 18.9036 14.2844 14.641 13.5178C10.3707 12.7437 6.63892 13.5554 6.30038 15.329Z",
    fill: "url(#paint4_radial_3819_33370)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4404 19.8305C9.17011 19.0564 5.99237 16.9521 6.33861 15.1259C6.68485 13.2997 10.4243 12.443 14.6946 13.2171C18.9649 13.9911 22.1427 16.0954 21.7964 17.9216C21.4502 19.7478 17.7108 20.6045 13.4404 19.8305ZM14.8639 12.3303C9.45479 11.3533 4.71512 12.4355 4.27654 14.7502C3.83797 17.0648 7.86977 19.7328 13.2712 20.7097C18.6802 21.6867 23.4199 20.6045 23.8585 18.2898C24.2971 15.9751 20.2653 13.3072 14.8639 12.3303Z",
    fill: "url(#paint5_linear_3819_33370)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2173 14.4867L13.7477 14.2236L13.6477 14.7422C13.2091 14.667 12.7936 14.6144 12.3859 14.5919C11.9781 14.5693 11.6164 14.5768 11.2933 14.6144C10.9778 14.652 10.7162 14.7271 10.5084 14.8248C10.3007 14.9301 10.1853 15.0653 10.1545 15.2457C10.1083 15.4862 10.1853 15.7041 10.3853 15.892C10.5854 16.0799 10.847 16.2527 11.1625 16.403C11.4779 16.5534 11.8319 16.6886 12.2243 16.8089C12.609 16.9291 12.9706 17.0343 13.2938 17.1395C13.6246 17.2372 13.8939 17.3349 14.1094 17.4251C14.3248 17.5153 14.4248 17.6055 14.4094 17.6957C14.4018 17.7483 14.3248 17.7858 14.1786 17.8084C14.0324 17.8309 13.8247 17.8159 13.54 17.7633C13.1245 17.6881 12.7629 17.5679 12.4474 17.3951C12.1319 17.2222 11.9473 17.0343 11.8703 16.8164L9.98523 16.4782L9.73132 17.8159L11.6164 18.1541L11.6549 17.9362C12.0858 18.124 12.5167 18.2818 12.9321 18.4021L12.8244 18.9582L14.294 19.2213L14.3941 18.7102C14.8326 18.7779 15.2481 18.8305 15.6559 18.853C16.0637 18.8831 16.4253 18.8756 16.7408 18.8455C17.064 18.8079 17.3179 18.7403 17.5256 18.6426C17.7257 18.5374 17.8411 18.4021 17.8796 18.2142C17.9257 17.9662 17.8488 17.7483 17.6487 17.5529C17.4487 17.3575 17.1794 17.1846 16.8562 17.0343C16.5331 16.884 16.1714 16.7412 15.779 16.621C15.3789 16.5007 15.0173 16.388 14.6864 16.2828C14.3556 16.1776 14.0709 16.0874 13.8478 15.9972C13.6246 15.907 13.5169 15.8169 13.5323 15.7267C13.5477 15.6515 13.6323 15.6139 13.7939 15.6064C13.9555 15.5989 14.1555 15.6064 14.3941 15.6515C14.5864 15.6891 14.7711 15.7342 14.948 15.8018C15.1327 15.8619 15.2943 15.9371 15.4328 16.0123C15.5713 16.0874 15.6944 16.1776 15.7867 16.2678C15.8791 16.358 15.9406 16.4481 15.9483 16.5383L17.8565 16.884L18.1027 15.5764L16.1945 15.2307L16.156 15.4561C16.0329 15.4035 15.8867 15.3359 15.7021 15.2682C15.5174 15.2006 15.3097 15.1255 15.0788 15.0578L15.1943 14.4566L15.2173 14.4867Z",
    fill: "url(#paint6_linear_3819_33370)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2584 14.2767L13.7888 14.0137L13.6887 14.5322C13.2502 14.4571 12.8347 14.4045 12.4269 14.3819C12.0191 14.3594 11.6574 14.3669 11.3343 14.4045C11.0188 14.442 10.7495 14.5172 10.5495 14.6149C10.3417 14.7201 10.2263 14.8554 10.1955 15.0357C10.1494 15.2762 10.2263 15.4942 10.4264 15.6821C10.6264 15.8699 10.888 16.0428 11.2035 16.1931C11.5189 16.3434 11.8729 16.4787 12.2653 16.5989C12.6577 16.7191 13.0116 16.8244 13.3348 16.9296C13.6656 17.0273 13.9349 17.125 14.1504 17.2152C14.3658 17.3053 14.4659 17.3955 14.4505 17.4857C14.4428 17.5383 14.3658 17.5759 14.2196 17.5984C14.0734 17.621 13.8657 17.6059 13.581 17.5533C13.1655 17.4782 12.8039 17.3579 12.4884 17.1851C12.173 17.0122 11.9883 16.8244 11.9114 16.6064L10.0263 16.2682L9.77234 17.6059L11.6574 17.9441L11.6959 17.7262C12.1268 17.9141 12.5577 18.0719 12.9732 18.1921L12.8654 18.7483L14.335 19.0113L14.4351 18.5003C14.8736 18.5679 15.2891 18.6205 15.6969 18.643C16.1047 18.6731 16.4664 18.6656 16.7818 18.6355C17.105 18.598 17.3589 18.5303 17.5666 18.4326C17.7667 18.3274 17.8821 18.1921 17.9206 18.0043C17.9668 17.7562 17.8898 17.5383 17.6898 17.3429C17.4897 17.1475 17.2204 16.9747 16.8972 16.8244C16.5741 16.6741 16.2125 16.5313 15.82 16.411C15.4199 16.2908 15.0583 16.1781 14.7275 16.0728C14.3966 15.9676 14.1119 15.8774 13.8888 15.7873C13.6656 15.6971 13.5579 15.6069 13.5733 15.5167C13.5887 15.4416 13.6733 15.404 13.8349 15.389C13.9965 15.3814 14.1966 15.389 14.4351 15.434C14.6274 15.4716 14.8121 15.5167 14.9891 15.5843C15.1737 15.6445 15.3353 15.7196 15.4738 15.7948C15.6123 15.8699 15.7354 15.9601 15.8277 16.0503C15.9201 16.1405 15.9816 16.2307 15.9893 16.3208L17.8975 16.6665L18.1437 15.3589L16.2355 15.0132L16.1894 15.2387C16.0663 15.186 15.9201 15.1184 15.7354 15.0508C15.5507 14.9831 15.343 14.908 15.1122 14.8403L15.2276 14.2391L15.2584 14.2767Z",
    fill: "url(#paint7_linear_3819_33370)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57362 3.4525C4.85864 4.4246 3.36039 5.80407 2.35213 7.46128C-0.173223 11.6182 1.3156 15.9973 5.68786 17.2379C8.30744 17.9785 11.3699 17.4231 13.9518 15.9695C15.6668 14.9974 17.165 13.618 18.1733 11.9607C20.6986 7.80383 19.2098 3.42472 14.8376 2.19339C12.218 1.45273 9.15551 1.99897 6.57362 3.46176V3.4525Z",
    fill: "url(#paint8_linear_3819_33370)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6626 4.69286L17.8522 3.3134L17.6637 3.41524C16.9193 2.70236 15.9488 2.13761 14.7709 1.80432C12.1042 1.04515 8.9852 1.6099 6.36561 3.10046C4.62236 4.09108 3.09584 5.48906 2.06874 7.18331C0.881445 9.14604 0.561066 11.1458 1.01337 12.8678L0.824907 12.9789L1.60701 14.3028C2.3797 15.6082 3.68949 16.6266 5.46101 17.1358C8.12771 17.895 11.2467 17.3302 13.8663 15.8397C15.6095 14.8491 17.1361 13.4511 18.1632 11.7568C19.6897 9.23862 19.7745 6.64633 18.6532 4.69286H18.6626Z",
    fill: "url(#paint9_linear_3819_33370)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59392 1.77722C3.85067 2.76784 2.32415 4.16582 1.29704 5.86006C-1.27542 10.091 0.241673 14.5442 4.68931 15.8033C7.35601 16.5625 10.475 15.9977 13.0946 14.5072C14.8378 13.5166 16.3644 12.1186 17.3915 10.4243C19.9639 6.19336 18.4468 1.74018 13.9992 0.481075C11.3325 -0.278094 8.2135 0.286653 5.59392 1.77722Z",
    fill: "url(#paint10_linear_3819_33370)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11029 2.65735C4.72511 3.44429 3.51897 4.54601 2.7086 5.88844C0.673237 9.2399 1.86995 12.7673 5.39414 13.7671C7.50489 14.3689 9.9737 13.9245 12.0562 12.7395C13.4414 11.9525 14.6475 10.8508 15.4579 9.50839C17.4932 6.15693 16.2965 2.62957 12.7723 1.62969C10.6616 1.02791 8.19276 1.4723 6.11029 2.65735Z",
    fill: "url(#paint11_linear_3819_33370)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41135 3.17549C5.04502 3.95317 3.85773 5.04564 3.05678 6.36029C1.04968 9.66546 2.23698 13.1465 5.70463 14.1279C7.7871 14.7204 10.2276 14.276 12.2724 13.1187C13.6388 12.3411 14.8261 11.2486 15.627 9.93394C17.6341 6.62878 16.4468 3.14771 12.9792 2.16635C10.8967 1.57383 8.45613 2.01822 6.41135 3.17549Z",
    fill: "url(#paint12_radial_3819_33370)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M6.41135 3.17549C5.04502 3.95317 3.85773 5.04564 3.05677 6.36029C1.04968 9.66546 2.23698 13.1465 5.70463 14.1279C7.7871 14.7204 10.2276 14.276 12.2724 13.1188C13.6388 12.3411 14.8261 11.2486 15.627 9.93394C17.6341 6.62878 16.4468 3.14771 12.9792 2.16635C10.8967 1.57383 8.45613 2.01822 6.41135 3.17549Z",
    fill: "url(#paint13_radial_3819_33370)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.132 12.887C10.0872 14.0536 7.64667 14.4887 5.5642 13.8962C2.08713 12.9055 0.909256 9.43373 2.91635 6.12857C3.7173 4.80465 4.91401 3.71219 6.27092 2.94376C8.3157 1.77723 10.7563 1.3421 12.8387 1.93462C16.3064 2.91599 17.4937 6.39705 15.4866 9.70222C14.6856 11.0261 13.4889 12.1186 12.132 12.887ZM5.49824 1.61059C3.77384 2.59195 2.25674 3.97142 1.23906 5.64714C-1.30514 9.83183 0.19311 14.2387 4.59363 15.4886C7.23206 16.2385 10.3228 15.683 12.9141 14.2109C14.6385 13.2296 16.1556 11.8501 17.1733 10.1744C19.7175 5.9897 18.2192 1.58281 13.8187 0.332962C11.1803 -0.416949 8.08955 0.138541 5.49824 1.61059Z",
    fill: "url(#paint14_linear_3819_33370)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.034 5.63703L12.8185 5.29447L12.5735 5.70183C12.5075 5.60925 12.4133 5.51667 12.3002 5.40557C12.1871 5.29447 12.0458 5.19263 11.8856 5.08154L12.5452 3.99833L12.4133 3.7854L12.1683 3.86872L12.1494 3.89649L11.3391 3.66504L10.7643 4.60937C10.4062 4.50753 10.0481 4.46124 9.66178 4.46124C9.28486 4.46124 8.91737 4.50753 8.56872 4.60937C8.3143 4.68344 8.07873 4.78528 7.85257 4.90563C7.76777 4.95192 7.68296 5.00747 7.60758 5.06302C7.31546 5.2667 7.07047 5.52593 6.87259 5.84996C6.60874 6.2851 6.48624 6.66468 6.50509 6.98872C6.53336 7.31275 6.62759 7.5905 6.7972 7.83121C6.96681 8.07192 7.19297 8.28486 7.46623 8.46076C7.7395 8.63667 7.9845 8.80332 8.22007 8.95145C8.45564 9.09958 8.63468 9.24771 8.75718 9.38658C8.8891 9.52545 8.90795 9.68284 8.80429 9.84023C8.7666 9.90504 8.71006 9.95133 8.63468 9.99762C8.58756 10.0254 8.54045 10.0439 8.47449 10.0624C8.3143 10.118 8.11642 10.1087 7.89026 10.0439C7.55104 9.95133 7.30604 9.76616 7.15528 9.48842C7.00451 9.21068 6.99508 8.88664 7.11758 8.50706L6.98566 8.29412L6.7972 8.42373L5.58164 8.08118L4.41319 10.0069L3.97974 10.2939L4.10224 10.5068L5.63818 10.942L5.87375 10.5531C6.11875 10.8586 6.39202 11.0993 6.69355 11.2752L6.26009 11.9881L5.94914 12.0714L6.08106 12.2844L7.27777 12.6269L7.83373 11.7104C8.1918 11.7937 8.5593 11.84 8.93621 11.8585C9.30371 11.8678 9.66178 11.8307 10.0104 11.7382C10.2649 11.6733 10.5098 11.5715 10.736 11.4419C10.8114 11.3956 10.8868 11.3493 10.9622 11.303C11.2543 11.0993 11.4993 10.8401 11.6971 10.5068C11.9704 10.0624 12.0929 9.67358 12.0741 9.34955C12.0552 9.02551 11.9516 8.73851 11.7725 8.48854C11.5935 8.24783 11.3673 8.03489 11.0941 7.84973C10.8208 7.66456 10.5664 7.49792 10.3308 7.34979C10.0952 7.20166 9.9162 7.05352 9.77486 6.91465C9.63351 6.77578 9.61467 6.62765 9.7089 6.47026C9.75601 6.3962 9.81255 6.33139 9.88793 6.29436C9.94447 6.26658 10.001 6.23881 10.0764 6.22955C10.246 6.19252 10.425 6.20177 10.6135 6.25732C10.7643 6.30361 10.9056 6.36842 11.0281 6.47026C11.1506 6.5721 11.2448 6.6832 11.3108 6.80355C11.3768 6.93317 11.4145 7.07204 11.4239 7.22943C11.4239 7.27572 11.4239 7.33127 11.4239 7.37756L11.2166 7.4794L11.3391 7.69234L12.8939 8.13673L14.3356 5.76664L14.2037 5.5537L13.9963 5.67406L14.034 5.63703Z",
    fill: "url(#paint15_linear_3819_33370)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75003 4.67618C7.66523 4.72247 7.58042 4.77802 7.50504 4.83357C7.21292 5.03725 6.96793 5.29648 6.77005 5.62051C6.5062 6.05564 6.3837 6.43523 6.40255 6.75926C6.43082 7.0833 6.52505 7.36104 6.69466 7.60176C6.86427 7.84247 7.09043 8.05541 7.36369 8.23131C7.63696 8.40722 7.88195 8.57386 8.11753 8.72199C8.3531 8.87012 8.53214 9.01825 8.65464 9.15713C8.78656 9.296 8.8054 9.45339 8.70175 9.61078C8.66406 9.67558 8.60752 9.72187 8.53214 9.76817C8.48502 9.79594 8.43791 9.81446 8.37195 9.83297C8.21176 9.88852 8.01388 9.87926 7.78773 9.81446C7.4485 9.72188 7.2035 9.53671 7.05273 9.25897C6.90197 8.98122 6.89254 8.65719 7.01504 8.2776L5.4791 7.84247L3.99969 10.2681L5.53564 10.7032L5.77121 10.3144C6.01621 10.6199 6.28947 10.8606 6.59101 11.0365L5.97852 12.0457L7.17523 12.3882L7.73119 11.4717C8.08926 11.555 8.45675 11.6013 8.83367 11.6198C9.20117 11.6291 9.55924 11.592 9.90789 11.4994C10.1623 11.4346 10.4073 11.3328 10.6335 11.2032C10.7088 11.1569 10.7842 11.1106 10.8596 11.0643C11.1517 10.8606 11.3967 10.6014 11.5946 10.2681C11.8679 9.82371 11.9904 9.43487 11.9715 9.11084C11.9527 8.7868 11.849 8.4998 11.67 8.24983C11.4909 8.00912 11.2648 7.79618 10.9915 7.61101C10.7183 7.42585 10.4638 7.2592 10.2283 7.11107C9.9927 6.96294 9.81366 6.81481 9.67232 6.67594C9.53097 6.53707 9.51213 6.38894 9.60636 6.23155C9.65347 6.15748 9.71001 6.09268 9.78539 6.05564C9.84193 6.02787 9.89847 6.00009 9.97385 5.99084C10.1435 5.9538 10.3225 5.97232 10.511 6.01861C10.6617 6.0649 10.8031 6.12971 10.9256 6.23155C11.0481 6.33339 11.1423 6.44449 11.2083 6.56484C11.2742 6.69446 11.3119 6.83333 11.3213 6.99072C11.3308 7.14811 11.3025 7.3055 11.2365 7.46288L12.7913 7.90728L14.233 5.53719L12.6782 5.0928L12.4332 5.50015C12.3673 5.40757 12.2731 5.31499 12.16 5.20389C12.0469 5.0928 11.9056 4.99096 11.7454 4.87986L12.405 3.79665L11.2083 3.4541L10.6335 4.39843C10.2754 4.29659 9.91731 4.2503 9.53097 4.2503C9.15405 4.2503 8.78656 4.29659 8.43791 4.39843C8.18349 4.4725 7.94791 4.57434 7.72176 4.69469L7.75003 4.67618Z",
    fill: "url(#paint16_linear_3819_33370)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M8.53075 9.76645C8.53075 9.76645 8.43652 9.81274 8.37056 9.83126C8.21037 9.88681 8.01249 9.87755 7.78634 9.81274C7.54134 9.73868 7.34346 9.62758 7.19269 9.46093C6.43885 9.22948 5.72271 8.89619 5.07252 8.5166L4.00773 10.2664L5.54367 10.7015L5.77924 10.3127C6.02424 10.6182 6.29751 10.8589 6.59904 11.0348L5.98655 12.044L7.18326 12.3865L7.73922 11.47C8.09729 11.5533 8.46479 11.5996 8.84171 11.6181C9.2092 11.6273 9.56727 11.5903 9.91592 11.4977C10.1703 11.4329 10.4153 11.3311 10.6415 11.2015C10.7169 11.1552 10.7923 11.1089 10.8676 11.0626C11.1598 10.8589 11.4048 10.5997 11.6026 10.2664C11.7063 10.0905 11.7911 9.92384 11.8571 9.75719C10.6509 9.89607 9.51074 9.91458 8.52133 9.77571L8.53075 9.76645Z",
    fill: "url(#paint17_linear_3819_33370)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M15.8632 9.0072C15.7501 9.23866 15.6276 9.47011 15.4957 9.70157C14.6947 11.0255 13.498 12.1179 12.1411 12.8864C10.0963 14.0529 7.65578 14.488 5.57331 13.8955C2.29412 12.9604 1.05971 9.81266 2.6145 6.68341C2.14335 6.24827 1.73816 5.81314 1.38951 5.41504C1.3424 5.4891 1.28586 5.57243 1.23874 5.65575C-1.30546 9.84044 0.192795 14.2473 4.59332 15.4972C7.23175 16.2471 10.3225 15.6916 12.9138 14.2195C14.6382 13.2382 16.1553 11.8587 17.173 10.183C17.5216 9.59973 17.7949 9.01646 18.0022 8.44246C17.3237 8.64614 16.6076 8.84056 15.8726 9.01646L15.8632 9.0072Z",
    fill: "url(#paint18_linear_3819_33370)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3819_33370",
    x1: 16.7334,
    y1: 25.9589,
    x2: 9.63504,
    y2: 13.5072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3819_33370",
    x1: 23.951,
    y1: 20.5763,
    x2: 4.06994,
    y2: 16.8074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3819_33370",
    x1: 17.2932,
    y1: 23.4374,
    x2: 10.075,
    y2: 10.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3819_33370",
    x1: 30.1106,
    y1: 9.05802,
    x2: 13.2384,
    y2: 5.85956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C05604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3819_33370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.72385 28.2671) rotate(-169.749) scale(7.87616 3.26417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AE20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3819_33370",
    x1: 23.4074,
    y1: 11.2932,
    x2: 6.92322,
    y2: 21.1435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEEF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDEC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDE66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDCE2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDDC5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3819_33370",
    x1: 10.2314,
    y1: 15.6395,
    x2: 18.48,
    y2: 17.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AA4604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#AD4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B76504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BD7105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BA6B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B25B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3819_33370",
    x1: 15.276,
    y1: 12.0348,
    x2: 13.7528,
    y2: 20.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDF2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDEC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FDE377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3819_33370",
    x1: 6.8858,
    y1: 3.37472,
    x2: 13.3397,
    y2: 16.3732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3819_33370",
    x1: 1.2385,
    y1: 14.6585,
    x2: 18.1099,
    y2: 4.7444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3819_33370",
    x1: 7.25956,
    y1: 16.1714,
    x2: 10.8714,
    y2: -0.42408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3819_33370",
    x1: 7.38086,
    y1: 13.9989,
    x2: 10.2419,
    y2: 0.852851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCBB07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3819_33370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.12595 7.8829) rotate(-77.2948) scale(6.70853 6.8165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AE20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3819_33370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.71825 8.82475) rotate(62.7809) scale(7.68442 7.76447)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F9F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F5E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F0DBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E9CBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E1B887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D7A261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CD8937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C16C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3819_33370",
    x1: 0.760895,
    y1: 5.86274,
    x2: 17.0726,
    y2: 9.5403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEEF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDEC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDE66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDCE2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDDC5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3819_33370",
    x1: 5.34098,
    y1: 2.44149,
    x2: 12.2412,
    y2: 14.6057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CE7B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C97504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BE6504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AB4A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3819_33370",
    x1: 5.21488,
    y1: 2.22701,
    x2: 12.1151,
    y2: 14.3912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDF2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDEC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FDE377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3819_33370",
    x1: 6.95901,
    y1: 12.1394,
    x2: 7.77811,
    y2: 9.66257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3819_33370",
    x1: 7.00504,
    y1: 15.289,
    x2: 8.4017,
    y2: 9.67965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.1dfbb5c79767420362ad7a07a92252ea.svg";
export { ForwardRef as ReactComponent };